import type { GeoData } from '@/models/interfaces/geo/GeoData'

export interface Ville {
  id: string
  name: string
  departementId: string
  latitude: number
  longitude: number
}

export interface Departement {
  id: string
  name: string
  regionId: string
}

export interface Region {
  id: string
  name: string
}

export const regions: Region[] = [{ id: 'centre', name: 'CENTRE' }]

export const departements: Departement[] = [
  { id: 'mefou-afamba', name: 'Méfou-et-Afamba', regionId: 'centre' },
]

export const villes: Ville[] = [
  {
    id: 'soa',
    name: 'SOA',
    departementId: 'mefou-afamba',
    latitude: 3.980856702481245,
    longitude: 11.591160423076305,
  },
]

/**
 * Resolves a query string (from URL or search) to GeoData.
 * Matches by ville id or name, case-insensitive.
 */
export function getGeoDataByCommuneQuery(value: string): GeoData | null {
  const normalized = value.trim()
  if (!normalized) return null
  const ville = villes.find(
    (v) =>
      v.id.toLowerCase() === normalized.toLowerCase() ||
      v.name.toLowerCase() === normalized.toLowerCase(),
  )
  if (!ville) return null
  return {
    name: ville.name,
    osmId: null,
    osmType: null,
    latitude: ville.latitude,
    longitude: ville.longitude,
    coords: { lng: ville.longitude, lat: ville.latitude },
  }
}
